<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'special-day',
        }
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.query.keyword)
                vm.data.keyword = vm.$route.query.keyword;

            if (vm.$route.query.store_id)
                vm.data.store_id = vm.$route.query.store_id;

            if (vm.$route.query.branch_id)
                vm.data.branch_id = vm.$route.query.branch_id;

            if (vm.$route.query.date_from)
                vm.data.date_from = vm.$route.query.date_from;

            if (vm.$route.query.date_to)
                vm.data.date_to = vm.$route.query.date_to;
        },
        newData() {
            var vm = this;

            var data = {
                keyword: null,
                store_id: null,
                branch_id: null,
                date_from: null,
                date_to: null,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;

            vm.success(vm.data);
            vm.$sidebar.hide();
        },
        fetchStore: async function (params) {
            const resp = await this.$api.Store.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchBranch: async function (params) {
            var newParams = {
                ...params,
                store_id: this.data.store_id
            }
            const resp = await this.$api.Branch.all(newParams)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
    }
}
</script>

<template>

    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('filter.label.keyword') }}</label>
                        <input type="text" class="form-control" v-model="data.keyword" id="product-title-input"
                            :placeholder="$t('filter.placeholder.keyword')" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.store')
                        }}</label>
                        <dynamic-select v-model="data.store_id" :placeholder="$t('special_day.placeholder.store')"
                            :loadOptions="fetchStore" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.branch')
                        }}</label>
                        <dynamic-select v-model="data.branch_id" :placeholder="$t('special_day.placeholder.branch')"
                            :loadOptions="fetchBranch" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.date_from') }}</label>
                        <datepicker v-model="data.date_from" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('special_day.label.date_to') }}</label>
                        <datepicker v-model="data.date_to" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="($ac.hasAccess('special_day_full_access') || ($ac.hasAccess('special_day_list')))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="primary" class="w-100" @click="submit"
                                    :disabled="$loading.get([routeName, 'list'].join('_'))">
                                    <loading :loading="$loading.get([routeName, 'list'].join('_'))">
                                        <i class="mdi mdi-filter-outline me-1"></i>
                                        {{ $t('basic.btn.filter') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>